import { useState, useEffect, useCallback, useMemo } from 'react'
import { useFinances } from 'hooks/useFinances'
import { selectData } from 'layouts/onboarding'
import { BalanceSheetRow } from 'layouts/authenticated/pages/dashboard/components/BalanceSheet/BalanceSheetRow'
import { BalanceSheetModalForm } from 'layouts/authenticated/pages/dashboard/components/BalanceSheetModalForm'
import { DeductionTypeSelection } from './DeductionTypeSelection'
import { useIntake } from 'hooks/useIntakeContext'
import { renderMuiFormField } from 'utils/forms/renderMuiFormField'
import styled from 'styled-components'
import Grid from '@mui/material/Grid'
import { AccountRow } from 'atoms/AssetsTable'
import AssetsTable from 'atoms/AssetsTable'
import { useModal } from 'components/modals'
import { AssetInnerTable } from 'atoms/AssetsTable'

const BalanceSheetToStyle = ({
  className,
  deductions,
  handleOpen,
  handleViewAsset,
}) => {
  return (
    <Grid className={className}>
      <BalanceSheetRow
        accounts={deductions}
        handleAddAccount={handleOpen}
        handleViewAccount={handleViewAsset}
        category={'deduction'}
        accountType={'Deductions'}
        addAccountButtonText={`Add A Deduction`}
        isDefaultExpanded
      />
    </Grid>
  )
}
const StyledDeductionsTable = styled(BalanceSheetToStyle)`
  .MuiPaper-root > .MuiAccordionSummary-root {
    padding: 0px;
    border-bottom: none;
    border-top: none;
  }
  .MuiPaper-root > .MuiAccordionSummary-root.Mui-expanded {
    background-color: #fff;
    border-top: none;
  }
  .MuiAccordionSummary-root > .MuiAccordionSummary-content {
    margin: 0px;
  }
  .MuiAccordionSummary-root p {
    font-size: 24px !important;
    font-weight: 500;
  }
  .MuiAccordionDetails-root {
    background-color: #fff;
    padding: 0px;
    border-bottom: none;
  }
  .MuiAccordionDetails-root > div {
    border: 1px solid #ddd;
    border-radius: 8px;
  }
  .MuiAccordionDetails-root > div:empty {
    border: none;
  }
  .MuiAccordionDetails-root > div > div:last-of-type {
    border-bottom: none;
  }
  .MuiAccordionDetails-root > button {
    text-transform: capitalize;
    font-size: 16px;
    font-weight: normal;
    border: 1px solid rgb(221, 221, 221);
    border-radius: 8px;
    width: 100%;
    padding: 16px;
  }
`

export const DeductionsStepReview = () => {
  const { deductionTypes } = selectData
  const { getAccounts, createOrUpdateAccount, deleteAccount } = useFinances()
  const { intakeState, updateIntakeStateAtKey } = useIntake()
  const [deductions, setDeductions] = useState()
  const [open, setOpen] = useState(false)
  const type = 'deduction'
  const [name, setName] = useState()
  const [subType, setSubType] = useState()
  const [sortKey, setSortKey] = useState()
  const [keepInRetirement, setKeepInRetirement] = useState()
  const [amount, setAmount] = useState()
  const [selectedDeductions, setSelectedDeductions] = useState()
  const { openModal } = useModal()

  // console.log(deductions)

  const showDeductionForm =
    (intakeState['deductionTypesToInput'] || 0)?.length > 0
  const storeDeductions = useCallback(async () => {
    const accounts = await getAccounts()
    setDeductions((accounts || []).filter(({ type }) => type === 'deduction'))
  }, [getAccounts])

  const deductionSum = (deductions || [])
    .map((deduction) => deduction.amount)
    .reduce((a, b) => a + b, 0)

  useEffect(() => {
    let loaded = false
    if (loaded) return

    storeDeductions()
    loaded = true
  }, [getAccounts, storeDeductions])

  const handleClose = useCallback(() => {
    setOpen(false)
    setName('')
    setSubType('')
    setAmount('')
    setSortKey('')
    setKeepInRetirement(false)
  }, [])

  // console.log(name)

  const handleSubmit = useCallback(async () => {
    handleClose()
  }, [handleClose])

  const handleOpen = useCallback(() => {
    setOpen(true)
  }, [])

  const handleViewAsset = useCallback(
    ({ typeSubTypeUuid, amount, subType, keepInRetirement, name }) => {
      setSortKey(typeSubTypeUuid)
      setSubType(subType)
      setAmount(amount)
      setKeepInRetirement(keepInRetirement)
      setName(name)
      setOpen(true)
    },
    []
  )

  const handleClick = (callback) => {
    return callback
  }

  const rows = useMemo(() => {
    const safeDeductions = deductions || []
    // console.log(safeAssets)

    const baseRows = [
      {
        header: 'Deductions',
        headerValue: deductionSum,
        expandable: true,
        addAccountRow: 'Deduction',
        content: (
          <>
            {safeDeductions.map((deduction, index) => (
              <AccountRow
                onClick={handleClick(() =>
                  openModal('editAccount', {
                    accountType: 'Deduction',
                    account: deduction,
                    getAccounts: storeDeductions,
                    // isAdmin: isAdmin,
                  })
                )}
                // onClick={handleViewAsset}
                key={index}
                name={deduction.name || 'Unnamed Account'}
                amount={deduction.amount || 0}
                img={
                  deduction?.policyNumber
                    ? selectData.annuityCarriers.find(
                        ({ value }) => value === deduction.carrier
                      )?.logo || ''
                    : deduction.externalInstitutionLogo
                }
                accountObject={deduction}
                subType={deduction.subType}
                linked={
                  deduction?.policyNumber ? true : deduction?.externaldeduction
                }
                signalLinked={deduction?.policyNumber ? true : false}
              />
            ))}
          </>
        ),
      },
    ]
    return baseRows
  }, [deductions, intakeState])

  return (
    <>
      {/* <BalanceSheetModalForm
        handleClose={handleClose}
        name={name}
        amount={amount}
        subType={subType}
        type={type}
        setSubType={setSubType}
        setName={setName}
        setAmount={setAmount}
        typeSubTypeUuid={sortKey}
        open={open}
        handleSubmit={handleSubmit}
        reloadAccounts={storeDeductions}
        subTypeOptions={deductionTypes}
        keepInRetirement={keepInRetirement}
        setKeepInRetirement={setKeepInRetirement}
        modalHeader={'Add/Edit a Deduction'}
        hideName
      /> */}
      {/* <BalanceSheetRow
        accounts={deductions}
        handleAddAccount={handleOpen}
        handleViewAccount={handleViewAsset}
        category={'deduction'}
        accountType={'Deductions'}
        addAccountButtonText={`Add a Deduction`}
        isDefaultExpanded
      /> */}

      {/* replace with the styled version */}
      {/* <StyledDeductionsTable
        deductions={deductions}
        handleOpen={handleOpen}
        handleViewAsset={handleViewAsset}
      /> */}

      <AssetsTable
        getAccounts={storeDeductions}
        rows={rows}
        color={'blue'}
        openByDefault={[0]}
        styleAdjust
        startingType="deduction"
      />
    </>
  )
}
